import { isEmpty } from 'lodash-es';
import React from 'react';

const EmptyFragment = () => <></>;

interface ISimpleTabSectionProps {
  activeTabIndex: number;
  sections: React.FC[];
}

export const SimpleTabSections = ({
  activeTabIndex = 0,
  sections = [EmptyFragment],
}: ISimpleTabSectionProps) => {
  if (isEmpty(sections)) return null;
  const ActiveSection = sections[activeTabIndex];
  return ActiveSection ? <ActiveSection /> : <div />;
};
